import { render, staticRenderFns } from "./AppInfoPage.vue?vue&type=template&id=905981ce&scoped=true"
import script from "./AppInfoPage.vue?vue&type=script&lang=js"
export * from "./AppInfoPage.vue?vue&type=script&lang=js"
import style0 from "./AppInfoPage.vue?vue&type=style&index=0&id=905981ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905981ce",
  null
  
)

export default component.exports